import { render, staticRenderFns } from "./Somos1V2IndicadorTipo1Card.vue?vue&type=template&id=8c84ff20&scoped=true"
import script from "./Somos1V2IndicadorTipo1Card.vue?vue&type=script&lang=js"
export * from "./Somos1V2IndicadorTipo1Card.vue?vue&type=script&lang=js"
import style0 from "./Somos1V2IndicadorTipo1Card.vue?vue&type=style&index=0&id=8c84ff20&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c84ff20",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8c84ff20')) {
      api.createRecord('8c84ff20', component.options)
    } else {
      api.reload('8c84ff20', component.options)
    }
    module.hot.accept("./Somos1V2IndicadorTipo1Card.vue?vue&type=template&id=8c84ff20&scoped=true", function () {
      api.rerender('8c84ff20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/customer-insigths/components/somos1V2/components/Somos1V2IndicadorTipo1Card.vue"
export default component.exports